import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';
import { routes } from './app.routes';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HttpSupplierDbService } from './core/services/http/httpSupplierDB.service';
import { provideL10nIntl, provideL10nTranslation } from 'angular-l10n';
import { HttpTranslationLoader, l10nConfig } from './l10n-config';
import { CountryService } from './core/services/other/country.service';
import { LanguageService } from './core/services/other/language.service';
import { MessageService } from 'primeng/api';
import { ToastHandlerService } from './core/services/other/tostHandler.service';
import { MaintenanceModeService } from './core/services/http/maintenanceMode.service';
import { MaintenanceModeGuard } from './core/guards/maintenanceModeGuard';
import { TokenGuard } from './core/guards/token.guard';

export function tokenGetter() {
  return localStorage.getItem('jwt');
}

export const appConfig: ApplicationConfig = {
  providers: [
    // Angular Config
    importProvidersFrom(HttpClientModule),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    BrowserModule,
    importProvidersFrom(
  JwtModule.forRoot({
        config: {
          tokenGetter: tokenGetter,
        },
      })
    ),
    // PrimeNG Config
    BrowserAnimationsModule,
    provideAnimations(),
    provideAnimationsAsync(),
    MessageService,
    // Service Configs
    HttpSupplierDbService,
    TokenGuard,
    MaintenanceModeGuard,
    MaintenanceModeService,
    CountryService,
    ToastHandlerService,
    LanguageService,
    // Translation Service Config
    provideL10nTranslation(l10nConfig, {
      translationLoader: HttpTranslationLoader,
    }),
    provideL10nIntl(),
  ],
};
